;import $ from 'jquery';
window.$ = window.jQuery = $;
import 'bootstrap';
import 'jquery.scrollto';
import '../vendor/ba-debug.min.js';

(function($){
//------------------------------------------------------------------------------------------------------------------------
    // (1) Page constructor

    // Page constructor
    window.Page = {

//------------------------------------------------------------------------------------------------------------------------
    // (2) Global variables

        // GTM
        dataLayer: window.dataLayer || [],

        // CSRF
        csrf_token: $('meta[name="csrf-token"]').attr('content'),

        // Responsive breakpoints
        mobileMaxWidth: 767,
        tabletMaxWidth: 991,

        // scrollTo
        /*scrollTo: {
            axis: 'y',
            duration: 300,
            offset: {
                left: 0,
                top: 0
            }
        },*/

        // Modal
        modal: {
            message: false,
            title: false
        },

        // Animation
        animation: 300,

//------------------------------------------------------------------------------------------------------------------------
    // (3) Application

        // Set layout
        setLayout: function(){
            // Mobile nav
            $(document).on('click', 'header .navbar .navbar-toggle[data-toggle="mobile-menu"]', function(e){
                e.preventDefault();
                $('body').toggleClass('push-menu');
            });

            // Load scrollTo
            //window.Page.loadScrollTo();

            // Load GTM
            //window.Page.loadGTM();
        },

        // Resize layout
        resizeLayout: function(){
        },

//------------------------------------------------------------------------------------------------------------------------
    // (4) scrollTo

        // Load scrollTo
        loadScrollTo: function(){
            // CTA
            $(document).on('click', 'a[href^="#"], a[href^="' + window.location.href + '#"]', function(e){
                e.preventDefault();
                window.Page.scrollToHash(this.hash);
            });

            // On load
            $(window).on('load', function(e){
                var hash = window.location.hash;
                if(/^\#[0-9a-z_-]+$/gi.test(hash) && $(hash).is(':visible')){
                    window.Page.scrollToHash(hash);
                }
            });
        },

        // Scroll to content
        scrollToHash: function(hash, params){
            if(!$(hash).is(':visible')) return false;

            // Override settings
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.scrollTo, params);

            // Scroll to content
            $(window).scrollTo(hash, settings);
            window.location.hash = hash;

            // Hide navbar on mobile view
            $('body').removeClass('push-menu');
            //$('.navbar-collapse').collapse('hide');
        },

//------------------------------------------------------------------------------------------------------------------------
    // (5) GTM Event

        // Load GTM
        loadGTM: function(){
            // CTA
            $(document).on('click', '[data-event="click"]', function(e){
                window.Page.sendEvent($(this).data('event-action'), $(this).data('event-category'), $(this).data('event-label'));
            });

            // On load
            $('[data-event="callback"]').each(function(i, target){
                window.Page.sendEvent($(target).data('event-action'), $(target).data('event-category'), $(target).data('event-label'));
            });
        },

        // GTM Event
        sendEvent: function(action, category, label){
            window.Page.dataLayer.push({
                event: action,
                eventAction: action,
                eventCategory: category,
                eventLabel: label
            });
        },

//------------------------------------------------------------------------------------------------------------------------
    // (8) Modals

        // Load modals
        loadModals: function(){
            // Show default modals
            $('.modal[data-show="true"]').each(function(i, target){
                $(target).modal();
            });

            // Bootstrap bugfix: new modals opened from an old one cannot be scrolled if the old one was dismissed at the same time
            $(document).on('hidden.bs.modal', '.modal', function(e){
                if($('.modal.show').length){
                    $('body').addClass('modal-open');
                }
            });

            // Modal is shown
            $(document).on('shown.bs.modal', '.modal', function(e){
                // Bootstrap bugfix: freshly opened modals lose autofocus
                $(':input[autofocus]:first', $(this)).focus();
                // Autoselect share links
                if($(':input.auto-select', $(this)).length){
                    var link = $(e.relatedTarget).attr('href');
                    $(':input.auto-select', $(this)).val(link).select();
                }
            });
        },

        // Show modal
        showModal: function(id, params){
            // Override settings
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.modal, params);
            if(!id) return false;

            // Get modal by ID
            var $modal = $('#modal-' + id);
            if(!$modal.length) return false;

            // Override default texts
            if(params !== false){
                $('.modal-title', $modal).html(settings.title ? settings.title : '');
                $('.modal-body', $modal).html(settings.message ? '<p>' + settings.message + '</p>' : '');
            }

            // Show modal
            $modal.modal();
        },

        // Show error modal
        showError: function(message){
            window.Page.showModal('error', { title: 'An error occured.', message: message });
        },

//------------------------------------------------------------------------------------------------------------------------

    };

//------------------------------------------------------------------------------------------------------------------------
    // (9) Document ready

    // Document ready
    $(function(){
        // Set layout
        window.Page.setLayout();

        // Resize layout
        window.Page.resizeLayout();
    });

//------------------------------------------------------------------------------------------------------------------------
    // (10) Window loaded

    // Window loaded
    $(window).on('load', function(e){
        // Resize layout
        window.Page.resizeLayout();
    });

//------------------------------------------------------------------------------------------------------------------------
    // (11) Window resized or orientation changed

    // Window resized or orientation changed
    $(window).on('orientationchange resize', function(e){
        // Resize layout
        window.Page.resizeLayout();
    });

//------------------------------------------------------------------------------------------------------------------------
    // (12) Window scrolled

    // Window scrolled
    $(window).on('scroll', function(e){
        // Resize layout
        window.Page.resizeLayout();
    });

//------------------------------------------------------------------------------------------------------------------------
})(jQuery);
